'use client'

import { useMutation } from "@tanstack/react-query"
import { API_Error, API_Success_Response } from "@/interfaces/api/response/api_response_types"
import { API_Validate_Code_Response } from "@/interfaces/api/login/forgotPassword/api_response_types"
import { validateCodeData } from "@/interfaces/api/login/forgotPassword/api_request_types"
import { validatePasswordCode } from "../requests/user"

export const useValidatePasswordCode = () => useMutation<API_Success_Response<API_Validate_Code_Response>, API_Error, validateCodeData>({
    retry: false,
    mutationFn:  validatePasswordCode
})